export const RESUME =
  "https://drive.google.com/file/d/1VwLd06HpPDJAYPaan3i-KhzyVg6I6_aT/view?usp=sharing";
